module.exports = __webpack_public_path__ + "img/btn-green-th.028e3800.png";